/**
 * Layout Component
 * Main layout with navigation sidebar
 */

import { Link, useLocation, useNavigate } from 'react-router-dom'
// import { useState, useEffect } from 'react'
import { useAuth } from '../hooks/useAuth'
// import { useNotificationToast } from '../hooks/useNotificationToast'
// import NotificationBell from './Notifications/NotificationBell'
// import { listNotifications } from '../services/notifications.service'

interface LayoutProps {
  children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const navigate = useNavigate()
  const { user, logout } = useAuth()
  // const [unreadCount, setUnreadCount] = useState(0)

  // Enable toast notifications for critical events
  // DISABLED: Notification feature is not currently in use
  // useNotificationToast()

  // Load unread count
  // DISABLED: Notification polling disabled to reduce unnecessary API calls
  // const loadUnreadCount = async () => {
  //   try {
  //     const response = await listNotifications({ is_read: 'false', limit: 1 })
  //     setUnreadCount(response.unread_count)
  //   } catch (error) {
  //     console.error('Failed to load unread count:', error)
  //   }
  // }

  // Poll notifications every 30 seconds
  // DISABLED: Notification feature preserved but not active
  // useEffect(() => {
  //   loadUnreadCount()
  //   const interval = setInterval(loadUnreadCount, 30000)
  //   return () => clearInterval(interval)
  // }, [])

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  const isActive = (path: string) => location.pathname === path

  return (
    <div style={styles.container}>
      {/* Sidebar */}
      <aside style={styles.sidebar}>
        <div style={styles.sidebarHeader}>
          <h1 style={styles.logo}>CyberLoan.ai</h1>
          {/* Notification bell disabled - feature not currently in use */}
          {/* <NotificationBell unreadCount={unreadCount} onRefresh={loadUnreadCount} /> */}
          <p style={styles.userEmail}>{user?.email}</p>
        </div>

        <nav style={styles.nav}>
          <Link
            to="/dashboard"
            style={{
              ...styles.navLink,
              ...(isActive('/dashboard') ? styles.navLinkActive : {}),
            }}
          >
            📊 儀表板
          </Link>

          <Link
            to="/api-keys"
            style={{
              ...styles.navLink,
              ...(isActive('/api-keys') ? styles.navLinkActive : {}),
            }}
          >
            🔑 API Keys
          </Link>

          <Link
            to="/bitfinex-api-keys"
            style={{
              ...styles.navLink,
              ...(isActive('/bitfinex-api-keys') ? styles.navLinkActive : {}),
            }}
          >
            🏦 Bitfinex 憑證
          </Link>

          <Link
            to="/bots"
            style={{
              ...styles.navLink,
              ...(isActive('/bots') ? styles.navLinkActive : {}),
            }}
          >
            🤖 Bot 管理
          </Link>

          <Link
            to="/reports"
            style={{
              ...styles.navLink,
              ...(isActive('/reports') ? styles.navLinkActive : {}),
            }}
          >
            📈 報表
          </Link>

          <Link
            to="/account"
            style={{
              ...styles.navLink,
              ...(isActive('/account') ? styles.navLinkActive : {}),
            }}
          >
            💰 帳戶資訊
          </Link>
        </nav>

        <div style={styles.sidebarFooter}>
          <button onClick={handleLogout} style={styles.logoutButton}>
            🚪 登出
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main style={styles.main}>{children}</main>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
  },
  sidebar: {
    width: '250px',
    backgroundColor: 'white',
    borderRight: '1px solid #e5e7eb',
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    height: '100vh',
    overflow: 'auto',
  },
  sidebarHeader: {
    padding: '30px 20px',
    borderBottom: '1px solid #e5e7eb',
  },
  // headerTop: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'space-between',
  //   marginBottom: '8px',
  // },
  logo: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#2563eb',
    margin: 0,
    marginBottom: '8px',
  },
  userEmail: {
    fontSize: '12px',
    color: '#666',
    wordBreak: 'break-word',
  },
  nav: {
    flex: 1,
    padding: '20px 0',
  },
  navLink: {
    display: 'block',
    padding: '12px 20px',
    color: '#333',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'background-color 0.2s',
  },
  navLinkActive: {
    backgroundColor: '#eff6ff',
    color: '#2563eb',
    fontWeight: '500',
    borderLeft: '3px solid #2563eb',
  },
  sidebarFooter: {
    padding: '20px',
    borderTop: '1px solid #e5e7eb',
  },
  logoutButton: {
    width: '100%',
    padding: '10px',
    backgroundColor: '#f3f4f6',
    color: '#333',
    border: 'none',
    borderRadius: '5px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  main: {
    marginLeft: '250px',
    flex: 1,
    minHeight: '100vh',
  },
}
